import axios from 'axios';
import env from '@/env';

export default axios.create({
  timeout: 30000,
  baseURL: `${env.API_BASE_URL}/m3cast-hdmi`,
});
